<template lang="pug">
include ../pug/svg

div.field.hidden(v-if="type === 'hidden'")
	Field(type="hidden" autocomplete="off" v-model="value" :name="name" :required="required" :disabled="disabled")
	
div.field(v-else :class="class")
	span.input(v-if="append && showAppend" :class="{disabled:disabled}")
		em {{appendValue}}
		em {{append}}
		
	template(v-if="type === 'password'")
		Field(:type="passwordType" :placeholder="computedPlaceholder" autocomplete="off" v-model="value" :name="name" :validateOnInput="true" @focus="focus" @keydown="keydown" @keyup="keyup" @blur="blur" :required="required" :disabled="disabled" :maxlength="maxlength" v-slot="{ meta: slotMeta, field: slotField }")
			//-input(v-bind="slotField" :type="passwordType")
			//-em valid: {{slotMeta.valid}}
		button.but.eye(v-if="showPassword && !disabled" type="button" @click="togglePasswordType") {{ passwordState }} Password
			+svg(svg-filename="iconHide" aria-hidden="true" alt="Show icon")
			
	Field(v-else-if="type === 'textarea'" as="textarea" :placeholder="computedPlaceholder" autocomplete="off" v-model="value" :name="name" :validateOnInput="validateOnInput" @focus="focus" @keydown="keydown" @keyup="keyup" @blur="blur" :required="required" :disabled="disabled" :maxlength="maxlength")
	
	Field(v-else :type="type" :placeholder="computedPlaceholder" autocomplete="off" v-model="value" :name="name" :validateOnInput="validateOnInput" @focus="focus" @keydown="keydown" @keyup="keyup" @blur="blur" :required="required" :disabled="disabled" :maxlength="maxlength" v-slot="{ meta: slotMeta, field: slotField }")
	
	label {{label}}
	span.err(:class="{hide:cancelled||!errors[name]||errors[name]==='-'}") {{errors[name]}}
</template>

<script>
import { Field } from 'vee-validate';
import { debounce } from '@/utilities/debounce'
export default {
	name: 'FieldText',
	props: {
		modelValue: [String, Number],
		validateOnInput: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			default: null
		},
		label: String,
		errors: {
			type: Object,
			default: () => ({})
		},
		cancelled: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: null
		},
		class: {
			type: String,
			default: null
		},
		maxlength: {
			type: Number,
			default: null			
		},
		numeric: {
			type: Boolean,
			default: false			
		},
		append: {
			type: String,
			default: null			
		},
		placeholder: {
			type: String,
			default: 'Unsupplied'			
		},
		type: {
			type: String,
			default: 'text',
			validator(value) {
				// The value must match one of these strings
				return ['text', 'password', 'email', 'search', 'number', 'tel', 'date', 'time', 'hidden', 'textarea'].includes(value);
			},
		},
	},
	emits: ['update:modelValue','focus','keydown','keyup','blur'],
	components: {
		Field,
	},
	data() {
		return {
			hasFocus: false,
			allowedKeys: ['Backspace','Shift','Tab','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','0','1','2','3','4','5','6','7','8','9'],
			passwordType: 'password',
			passwordState: 'Show',
			prevent: false,
			debounceKeyUp: null,
		}
	},
	mounted() {
		this.debounceEmit = debounce((name, event) => {
//console.log('debounceKeyUp:', name, event);
//			this.emitKeyUp();
			this.emit(name, event);
		}, 1000);
	},
	computed: {
		computedPlaceholder() {
			return this.hasFocus ? '' : this.placeholder;
		},
		value: {
			get() {
				return this.modelValue;
			},
			set(value) {
				this.$emit('update:modelValue', value);
			}
		},
		appendValue() {
			return (this.value !== '') ? this.value : this.placeholder;
		},
		showAppend() {
			return (this.numeric || this.type === 'number') ? (this.value !== '' && this.value !== null) : this.value;
		},
		showPassword() {
			return (this.value);
		},
	},
	methods: {
		togglePasswordType() {
			if (this.passwordType === 'password') {
				this.passwordType = 'text';
				this.passwordState = 'Hide';
			} else {
				this.passwordType = 'password';
				this.passwordState = 'Show';
			}
		},
		emit(name, event) {
//console.log('emit:', name, event);
			this.$emit(name, event);
		},
		focus() {
			this.hasFocus = true;
			this.emit('focus', event);
		},
		keydown(event) {
			if ((this.numeric || this.type === 'number' ) && this.allowedKeys.indexOf(event.key) < 0) {
				// restricted key
				event.preventDefault();
				this.prevent = true;
				return;
			}
			
			this.emit('keydown', event);
		},
		keyup(event) {
			if (!this.prevent) {
//				this.emit('keyup', event);
				this.debounceEmit('keyup', event);
			}
			
			this.prevent = false;
		},
		blur(event) {
			this.hasFocus = false;
			this.emit('blur', event);
		},
	},
}
</script>

<style lang="scss">
	input[placeholder^="•••"][placeholder$="•••"]:placeholder-shown { // 3 or more dots
		font-size: 2.5rem !important;
		letter-spacing: .05em !important;
		&:not(:disabled) {
			&::placeholder {
				color: var(--pan-lnk) !important;
			}
		}
	}
</style>
